import { useState, useMemo, useEffect } from 'react';
import { ITEMS_PER_PAGE_MOBILE, ITEMS_PER_PAGE_DESKTOP } from '../../utils/emendas/constants';

export const usePagination = (data, isMobile) => {
  const itemsPerPage = isMobile ? ITEMS_PER_PAGE_MOBILE : ITEMS_PER_PAGE_DESKTOP;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage, itemsPerPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data.length]);

  return {
    paginatedData,
    currentPage,
    totalPages,
    itemsPerPage,
    setCurrentPage
  };
};
